module.exports = __webpack_public_path__ + "img/DW365-212.1619da94.jpg";